import type { FaireProductEntity } from "../../entity_types/product";

export const p_mxvga2w6vm: FaireProductEntity = {
  token: "p_mxvga2w6vm",
  type: "product",
  name: "Drawstring Long Skirt – Prepack of 5 Colors – Boho Stripes",
  brandToken: "b_vn9q3djcqf",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/aaeb9ac0b441583a68b7fd7e6b011b4ef86f05cd53622b308c2b296abb0eda3b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cea9c482a59cc535a28d6b9b3411a1b2caaf02f4c173f645480f4d5e60e4ff62.jpeg",
    "https://cdn.faire.com/fastly/f587a4d8cd72b56f6d6d49103532ad348285b763c8727371eab6529862ed5ac9.jpeg",
    "https://cdn.faire.com/fastly/3da678222329b493502b253cf01123ee1c82558b744690847bffdf270daba926.jpeg",
    "https://cdn.faire.com/fastly/e5a22bbb5d5425a7ea2bfe10669d9e8b2b59134cbfb0525c407ceedb05e4e1a2.jpeg",
    "https://cdn.faire.com/fastly/2d6ab16141eeaa55c88245742631e94ea29a59ff362a3f34dc7e60a50fd2a7ee.jpeg",
    "https://cdn.faire.com/fastly/e10f25d74c910ccc958d6ba9321ea531c56789c7159be88b27e12fa89e646940.jpeg",
    "https://cdn.faire.com/fastly/0bb116e44993157294c277011a1135edfc1e7256c60525f212ae3937b966f8e9.jpeg",
    "https://cdn.faire.com/fastly/47db8598e7217d54b5ec4e93b1664e54be85004cf7bacb5dd7dd77a2cce02582.jpeg",
    "https://cdn.faire.com/fastly/a83fb838013c7743f67856b721751c8ef394b0a6c02952a5ce354c0a9c9b1951.jpeg",
  ],
  priceDollars: 138.57,
  description:
    "Long skirts with pockets, you spoke, and we listened! Office day or day off, fashion meets functionality, embraced by the comfort you deserve. Classy yet casual, Katmandu has you covered, whatever adventure your day may bring. Handcrafted by friends/family in Nepal, our drawstring long skirt comes in an abundance of colors to choose from. Treat yourself to the most comfortable threads on earth. And you know what's more? With every single purchase, you're helping an artisan get fair compensation for their talent and dedication. Help us change the world - one day at a time. Treat yourself, we know you've been good!\n\nBrand: Katmandu Trading Company\nCountry Of Origin: Handmade in Nepal\nAvailability: Limited\nMaterial: Handwoven organic khaddar cotton\nSizing: Free size/Fits up to 42\" waist\nSpecial Features: Secret pocket, wrinkle-resistant, natural dyes\nAdditional Information: Machine washable, elastic waist, drawstrings, hanging straps/keyring holders ",
  tags: [],
  msrpDollars: 277.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:05.638Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
